var Meetings = new (class Meetings extends AbstractModule {

  constructor() {
    super("Meetings");
  }

  _initData(data) {
    this._autoInit({
      "enabled"            : [ data.widget.meetings_enabled, false ],
      "meeting_types_list" : [ data.widget.meeting_types, false ],
      "meeting"            : [ null, null ]
    });
  }

  async set(meeting_type, day, hour, timezone, callback) {
    let send_data = {
      'key': this.app._api_key,
      'token': this.app._guest_token,
      'meeting_type': meeting_type,
      'day': day,
      'hour': hour,
      'timezone': timezone,
      'language': this.app._language
    };

    let ajaxData = await Ajax.call('/api/set_meeting', send_data);
    if (typeof callback == "function") callback(ajaxData);
    return ajaxData;
  }

  async cancel(token, callback, force) {
    if (typeof force == 'undefined') {
      force = false
    }

    let send_data = {
      'key': this.app._api_key,
      'token': this.app._guest_token,
      'meeting': token,
      'force': force
    };

    if (typeof callback == 'undefined') {
      callback = null;
    }

    let ajaxData = await Ajax.call('/api/cancel_meeting', send_data);
    if (typeof callback == "function") callback(ajaxData);
    return ajaxData;
  }

  async reschedule(token, day, hour, timezone, callback) {
    let send_data = {
      'key': this.app._api_key,
      'token': this.app._guest_token,
      'meeting': token,
      'day': day,
      'hour': hour,
      'timezone': timezone
    };

    let ajaxData = await Ajax.call('/api/reschedule_meeting', send_data);
    if (typeof callback == "function") callback(ajaxData);
    return ajaxData;
  }

  async getTypes(meeting_type_id, nd_days, callback) {
    let url;
    let send_data = {
      'key': this.app._api_key,
      'language': this.app._language.substr(0,2),
      'token': this.app._guest_token
    }
    if (typeof meeting_type_id == 'undefined' || meeting_type_id == null) {
      url         = '/api/get_meeting_types';
    } else {
      send_data["meeting_type"] = meeting_type_id;
      send_data["nb_days"]      = nd_days;
      url         = '/api/meeting_wording_and_availabilities';
    }

    if (typeof callback == 'undefined') {
      callback = null;
    }

    let ajaxData = await Ajax.call(url, send_data);
    if (typeof callback == "function") callback(ajaxData);
    return ajaxData;
  }

});
